<script lang="ts">
  import { page } from '$app/stores'
  import { onMount } from 'svelte'

  import { configureScope } from '@sentry/core'
  import LogRocket from 'logrocket'
  import { identifyGoogleClickUser, reportError, track } from 'src/utils/track'

  onMount(() => {
    identifyGoogleClickUser($page?.url)

    try {
      if (import.meta.env.PROD && $page?.url?.pathname?.startsWith('/stays')) {
        LogRocket.init('yqwzvj/airheart', {
          shouldDebugLog: false,
          shouldParseXHRBlob: true,
        })

        // if ($page?.url?.searchParams?.has('uid')) {
        //   let uid = $page.url.searchParams.get('uid')
        //   LogRocket.identify(uid, {
        //     verification: $page.url.searchParams.get('verification') ?? 'false',
        //   })
        // }

        LogRocket.getSessionURL(function (sessionURL) {
          track('LogRocket Session', {
            sessionURL: sessionURL,
          })
          configureScope((scope) => {
            scope.setExtra('sessionURL', sessionURL)
          })
        })
      }
    } catch (err) {
      reportError(err)
    }

    // try {
    //   FullStory.init({ orgId: 'ZMX8D', devMode: import.meta.env.DEV })
    // } catch (e) {
    //   reportError(e)
    // }
  })
</script>
